import { Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, LogOut, LogIn, UserCircle2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const BrandHeader = ({ minimal = false }) => {
  const navigate = useNavigate();
  const { auth, isAuthed, logout } = useAuth() || {};
  const isAdmin = auth?.role === "admin";

  return (
    <header
      data-testid="brand-header"
      className="sticky top-0 z-30 w-full backdrop-blur-xl bg-black/80 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
        <a
          href="https://fenance.de/"
          target="_top"
          data-testid="brand-logo-link"
          className="flex items-center gap-3"
        >
          <img
            src="/logo-white-orange.png"
            alt="feNANCE · CFO as-a-Service"
            className="h-12 w-auto"
          />
        </a>

        <div className="flex items-center gap-4">
          {!minimal && (
            <div className="hidden md:flex items-center gap-2">
              <span className="font-display text-[0.7rem] tracking-[0.25em] uppercase text-white/60">
                Tragfähigkeits-Check
              </span>
              <span className="text-white/20">/</span>
              <span className="text-xs tracking-wide text-white/40">
                Mission Control · Wert steuern
              </span>
            </div>
          )}

          {isAuthed ? (
            <div className="flex items-center gap-2">
              {!isAdmin && (
                <Link
                  to="/mein-verlauf"
                  data-testid="header-dashboard-link"
                  className="flex items-center gap-2 h-9 px-3 border border-white/15 text-white/80 hover:border-brand-orange hover:text-brand-orange transition-colors text-xs uppercase tracking-wider"
                >
                  <LayoutDashboard className="h-4 w-4" /> Mein Verlauf
                </Link>
              )}
              <button
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                data-testid="header-logout-btn"
                className="flex items-center gap-2 h-9 px-3 text-white/50 hover:text-white transition-colors text-xs uppercase tracking-wider"
                title={auth?.email}
              >
                <LogOut className="h-4 w-4" /> Abmelden
              </button>
            </div>
          ) : (
            <Link
              to="/login"
              data-testid="header-login-link"
              className="flex items-center gap-2 h-9 px-3 border border-white/15 text-white/80 hover:border-brand-orange hover:text-brand-orange transition-colors text-xs uppercase tracking-wider"
            >
              <LogIn className="h-4 w-4" /> Anmelden
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default BrandHeader;
